import React, { Component } from 'react';
import { USER_ICON, EYE_ICON, EYE_SLASH_ICON } from 'assets/constants/Icons';
import {
    SECRET_KEY,
    PHONE_NUMBER_PATTERN,
    emailPattern,
    passwordMatchPattern,
    TYPE_SUCCESS,
    TYPE_FAIL,
    TYPE_INFO,
    INTERVAL,
} from 'assets/constants/Constants';
import md5 from 'md5';
import Spinner from 'components/Spinner';
import CryptoJS from 'crypto-js';
import ShowToast from 'components/ShowToast';
import Select from 'react-select';
import { fetchMetadata, toCapitaliseWord } from 'lib/utils';
import { getRoleListCall, createUserCall, UpdateUserCall, getUserList, createHistoryList, getRegionList, getUserDetails } from 'lib/axiosUtils';
import { LOG_TEXT, MODULE_NAMES } from 'assets/constants/Constants';

export class CreateUserPage extends Component {
    constructor(props) {
        super(props);

        const editData = this.props.history.location.state;
        this.state = {
            isLoading: true,
            isUsernamePresent: false,
            userId: editData ? editData._id : null,
            firstName: editData ? editData.first_name : '',
            lastName: editData ? editData.last_name : '',
            emailId: editData ? editData.email_id : '',
            phoneNumber: editData ? editData.phone_number : '',
            userName: editData ? editData.username : '',
            password: editData ? editData.password : '',
            confirmPassword: editData ? editData.password : '',
            userRole: editData ? editData.role : '',
            isFromProfile: editData ? editData.isFromProfile : '',
            siteList: [],
            roleList: [],
            userList: [],
            regionList: [],
            regionListComponent: [],
            error: {},
            selectProfile:
                editData && editData.select_profile
                    ? { value: editData.select_profile, label: editData.select_profile }
                    : '',
            selectedEmployer: editData
                ? editData.company_id
                    ? { value: editData.company_id, label: editData.company_id }
                    : null
                : null,
            employerUnit: editData
                ? editData.employer_id
                    ? { value: editData.employer_id, label: editData.employer_id }
                    : null
                : null,
            selectedPartner: editData
                ? editData.partner_id
                    ? { value: editData.partner_id, label: editData.partner_id }
                    : null
                : null,
            selectedTrainingPartner: editData
                ? editData.partner_id
                    ? { value: editData.partner_id, label: editData.partner_id }
                    : null
                : null,
            profileOptions: [
                { value: 'employer', label: 'Employer' },
                { value: 'training partner', label: 'Training Partner' },
            ],
            PartnerListComponent: '',
            setPartnerList: '',
            setPartnerComponent: '',
            employerList: [],
            list: [],
            employerUnitComponent: '',
            setDisableTrainingPartner: true,
            setDisableEmployerUnit: true,
            partnerList: '',
            setTrainingPartnerComponent: '<option> Training Partner List </option>',
            roleListComponent: '<option> Select User Role </option>',
            showPassword: false,
            showConfirmPassword: false,
            auditflag: editData ? editData.audit_enable : false,
        };
    }

    async componentDidMount() {
        const [roleData, userListData, regionData] = await Promise.all([
            getRoleListCall({}, {}),
            getUserList({}, {}),
            getRegionList({}, {}),
        ]);
        const roleListComponent =
            roleData?.data?.result?.map((role) => ({
                label: role.user_role,
                value: role._id,
            })) || [];
        this.setState(
            {
                roleList: roleData.data.result,
                isLoading: false,
                userList: userListData.data.result,
                regionList: regionData.data.result,
            },
            async () => { 
                this.setListComponent();
                // this.fetchEmployerList();
                this.setUserRoleComponent();
                const currentRegionList = this.setRegionListComponent();
                
                //Check if editing a user
                const { userRole,userId } = this.state;
                const selectedRole = roleListComponent.find((r) => r.value === userRole);
                if (
                selectedRole &&
                selectedRole.label?.toLowerCase() === "sales"
                ) {
                this.userRoleChaneHandler(selectedRole);
                await this.fetchUserRegions(userId, currentRegionList);
                }
                this.setState({ isLoading: false });
            }
        );
    }   
    fetchUserRegions = async (userId, currentRegionList) => {
        try {
          if (!userId) return;
          const response = await getUserDetails({}, {}, userId);
          const user = response?.data?.result;
          if (!user || !Array.isArray(user.region_id)) return;
      
          const sourceList = currentRegionList || this.state.regionListComponent;
          const selectedRegions = sourceList.filter((region) =>
            user.region_id.includes(region.value)
          );
          this.setState({ selectedRegions });
        } catch (error) {
          console.error("Error fetching user regions:", error);
        }
    };
    setRegionListComponent = () => {
        const { regionList } = this.state;
        let listComponent = [];
        if (Array.isArray(regionList) && regionList.length > 0) {
            listComponent = regionList.map((item) => {
                return {
                    label: toCapitaliseWord(item.name || ""),
                    value: item._id,
                };
            });
            this.setState({ regionListComponent: listComponent });
        } else {
            this.setState({ regionListComponent: [] });
        }
        return listComponent;
    };
    setUserRoleComponent = () => {
        if (this.state.roleList.length > 0) {
            const listComponent = this.state.roleList.map((item) => {
                if (this.state.userRole) {
                    if (this.state.userRole === item._id) {
                        this.setState({
                            userRole: { label: toCapitaliseWord(item.user_role), value: item._id },
                        });
                    }
                }
                return { label: toCapitaliseWord(item.user_role), value: item._id };
            });
            this.setState({
                roleListComponent: listComponent,
            });
        }
    };

    firstNameChangeHandler = (event) => {
        this.setState({
            firstName: event.target.value,
        });
    };

    lastNameChangeHandler = (event) => {
        this.setState({
            lastName: event.target.value,
        });
    };

    emailIdChangeHandler = (event) => {
        this.setState({
            emailId: event.target.value,
        });
    };

    phoneNumberChangeHandler = (event) => {
        this.setState({
            phoneNumber: event.target.value,
        });
    };

    userNameChangeHandler = (event) => {
        this.setState({
            userName: event.target.value,
        });
    };

    handleShowPasswordClick = (event) => {
        if (!this.state.userId) {
            this.setState({
                showPassword: !this.state.showPassword,
            });
        }
    };

    handleShowConfirmPasswordClick = (event) => {
        if (!this.state.userId) {
            this.setState({
                showConfirmPassword: !this.state.showConfirmPassword,
            });
        }
    };

    usernameUniqueHandler = async (event) => {
        if (event.target.value) {
            if (!this.state.userId) {
                const userFound = this.state.userList.find(
                    (findItem) =>
                        findItem.username.trim().toLowerCase() ===
                        event.target.value.trim().toLowerCase()
                );
                if (userFound) {
                    ShowToast(
                        'Username already present, please try with different username!',
                        TYPE_FAIL,
                        INTERVAL,
                        '',
                        ''
                    );
                    this.setState({
                        isUsernamePresent: true,
                        userName: '',
                    });
                } else {
                    this.setState({
                        isUsernamePresent: false,
                    });
                }
            }
        }
    };

    emailUniqueHandler = (event) => {
        if (event.target.value) {
            if (!this.state.userId) {
                const userFound = this.state.userList.find(
                    (findItem) =>
                        findItem.email_id.trim().toLowerCase() ===
                        event.target.value.trim().toLowerCase()
                );
                if (userFound) {
                    ShowToast(
                        'Email Id already present, please try with different email id!',
                        TYPE_FAIL,
                        INTERVAL,
                        '',
                        ''
                    );
                    this.setState({
                        emailId: '',
                    });
                }
            }
        }
    };

    passwordChangehandler = (event) => {
        this.setState({
            password: event.target.value,
        });
    };

    confirmPasswordChangehandler = (event) => {
        this.setState({
            confirmPassword: event.target.value,
        });
    };

    userRoleChaneHandler  = (selectedOption) => {
        const isSales = selectedOption?.label?.toLowerCase() === "sales";
        this.setState({
            userRole: selectedOption,
            showRegion: isSales,
            selectedRegions: [], // reset regions when role changes
        });
    };

    // --- handle region change (multi-select)
    regionChangeHandler = (selectedOptions) => {
        this.setState({ selectedRegions: selectedOptions });
    };

    isFormValid = () => {
        let isValid = true;
        let error = {};

        if (!this.state.firstName) {
            isValid = false;
            error.firstName = 'Please enter first name';
        }

        if (!this.state.lastName) {
            isValid = false;
            error.lastName = 'Please Enter last name';
        }

        if (!this.state.emailId) {
            isValid = false;
            error.emailId = 'Please enter email id';
        }

        if (this.state.emailId) {
            if (!emailPattern.test(this.state.emailId)) {
                isValid = false;
                error.emailId = 'Please enter valid email address.';
            } else {
                if (!this.state.userId) {
                    const findUser = this.state.userList.find(
                        (findItem) =>
                            findItem.email_id.trim().toLowerCase() ===
                            this.state.emailId.trim().toLowerCase()
                    );
                    if (findUser) {
                        isValid = false;
                        error.emailId =
                            'Email Id already present, please try with different email id';
                    }
                }
            }
        }

        if (!this.state.phoneNumber) {
            isValid = false;
            error.phoneNumber = 'Please enter phone number';
        }

        if (this.state.phoneNumber !== 'undefined') {
            if (!PHONE_NUMBER_PATTERN.test(this.state.phoneNumber)) {
                isValid = false;
                error.phoneNumber = 'Please enter valid phone number.';
            }
        }

        if (!this.state.userName) {
            isValid = false;
            error.userName = 'Please enter username';
        } else {
            if (this.state.isUsernamePresent) {
                if (this.state.userId === null) {
                    isValid = false;
                    error.userName = 'Please enter different username';
                }
            } else {
                if (this.state.userName) {
                    if (!this.state.userId) {
                        const findUser = this.state.userList.find(
                            (findItem) =>
                                findItem.username.trim().toLowerCase() ===
                                this.state.userName.trim().toLowerCase()
                        );
                        if (findUser) {
                            isValid = false;
                            error.userName =
                                'Username already present, please enter different username';
                        }
                    }
                }
            }
        }

        if (!this.state.password) {
            isValid = false;
            error.password = 'Pleae enter password';
        }

        if (this.state.password) {
            if (this.state.userId === null) {
                if (!passwordMatchPattern.test(this.state.password)) {
                    isValid = false;
                    error.password = 'Please enter valid password';
                    ShowToast(
                        'Password must be minimum eight characters including one uppercase letter,\n one special character and alphanumeric characters',
                        TYPE_INFO,
                        INTERVAL,
                        this.props,
                        ''
                    );
                }
            }
        }

        if (!this.state.confirmPassword) {
            isValid = false;
            error.confirmPassword = 'Please enter confirm password';
        }

        if (this.state.password !== this.state.confirmPassword) {
            isValid = false;
            error.confirmPassword = 'Entered password and confirm password does not match';
        }

        if (!this.state.userRole) {
            isValid = false;
            error.userRole = 'Please select user role';
        }

        if (
            this.state.selectedEmployer === null &&
            this.state.selectProfile &&
            this.state.selectProfile.label === 'Employer'
        ) {
            isValid = false;
            error.selectedEmployerError = 'Please select Employer';
        }

        if (this.state.employerUnit === null && this.state.setDisableEmployerUnit === false) {
            isValid = false;
            error.employerUnitError = 'Please select the Employer unit';
        }

        if (
            this.state.selectedPartner === null &&
            this.state.selectProfile &&
            this.state.selectProfile.label === 'Training Partner'
        ) {
            isValid = false;
            error.selectedPartnerError = 'Please select the Project';
        }

        if (
            this.state.selectedTrainingPartner === null &&
            this.state.setDisableTrainingPartner === false
        ) {
            isValid = false;
            error.selectedTrainingPartnerError = 'Please select the training partner';
        }

        this.setState({
            error,
        });
        return isValid;
    };

    createUserHandler = async (event) => {
        event.preventDefault();
        if (this.isFormValid()) {
            this.setState({ isLoading: true });
            const requestData = {
                userFirstName: this.state.firstName,
                userLastName: this.state.lastName,
                userEmailId: this.state.emailId,
                userPhoneNumber: this.state.phoneNumber,
                userName: this.state.userName.trim().toLowerCase(),
                userPassword:
                    this.state.userId === null ? md5(this.state.password) : this.state.password,
                displayPass: CryptoJS.AES.encrypt(this.state.password, SECRET_KEY).toString(),
                userType: this.state.userType,
                userRole:
                    this.state.userRole && this.state.userRole.value
                        ? this.state.userRole.value
                        : '',
                userSelectProfile:
                    this.state.selectProfile && this.state.selectProfile.label
                        ? this.state.selectProfile.label
                        : null,
                userSelectedEmployer:
                    this.state.selectProfile.label === 'Employer'
                        ? this.state.selectedEmployer
                            ? this.state.selectedEmployer.value
                            : null
                        : null,
                userEmployerUnit:
                    this.state.selectProfile.label === 'Employer'
                        ? this.state.employerUnit
                            ? this.state.employerUnit.value
                            : null
                        : null,
                userSelectedTrainingPartner:
                    this.state.selectProfile.label === 'Training Partner' &&
                    this.state.selectedPartner.label !== 'TIMES-PRO'
                        ? this.state.selectedTrainingPartner
                            ? this.state.selectedTrainingPartner.value
                            : null
                        : null,
                auditflag: this.state.auditflag,
                userRegion: Array.isArray(this.state.selectedRegions)
                    ? this.state.selectedRegions.map((region) => region.value)
                    : [],
            };
            let userResponse = null;
            let auditresponse=null;
            let userData = JSON.parse(localStorage.getItem('userData'));
            let userID = userData._id;
            let logText = LOG_TEXT.USER_ADDED;
            let moduleName = MODULE_NAMES.USER_MASTER;

            if (this.state.userId === null) {
                userResponse = await createUserCall({}, requestData);
            } else {
                userResponse = await UpdateUserCall({}, requestData, this.state.userId);
            }

            if (userResponse.statusCode === 200) {
                if (this.state.userId === null) {
                    const usersData = userResponse.data.result;
                    const auditData = {
                        logText,
                        userID,
                        moduleName,
                        doc_id: usersData._id
                    };
                    auditresponse = await createHistoryList({}, auditData);
                    ShowToast(
                        'User created Successfully',
                        TYPE_SUCCESS,
                        INTERVAL,
                        this.props,
                        `${this.state.isFromProfile ? 'bom-list' : '/user-page'}`
                    );
                } else {
                    ShowToast(
                        'User updated Successfully',
                        TYPE_SUCCESS,
                        INTERVAL,
                        this.props,
                        `${this.state.isFromProfile ? 'bom-list' : '/user-page'}`
                    );
                }
                this.props.history.push(`${this.state.isFromProfile ? 'bom-list' : '/user-page'}`);
            }
        }
    };

    cancelHandler = () => {
        this.props.history.push(`${this.state.isFromProfile ? 'bom-list' : '/user-page'}`);
    };

    // fetchPartnerList = async () => {
    //     try {
    //         const response = await getPartnerList({},{});
    //         this.setState({
    //             partnerList: response.data.result
    //         },
    //             () => {
    //                 this.state.partnerList.forEach((item) => {
    //                     if (this.state.selectedPartner) {
    //                         if (item._id === this.state.selectedPartner.value) {
    //                             this.setState({
    //                                 selectedPartner: { label: item.partner_name, value: item.partner_name.toLocaleLowerCase() }
    //                             })
    //                             if (item.partner_name === "TIMES-PRO") {
    //                                 this.setState({
    //                                     setDisableTrainingPartner: true,
    //                                     selectedTrainingPartner: null
    //                                 })
    //                             }
    //                         }
    //                     }
    //                     if (this.state.selectedTrainingPartner) {
    //                         if (item._id === this.state.selectedTrainingPartner.value) {
    //                             this.setState({
    //                                 selectedTrainingPartner: { label: item.training_partner, value: item._id }
    //                             })
    //                         }
    //                     }
    //                 });
    //             })
    //         return response;
    //     }
    //     catch (error) {
    //         console.log("Error Occurred while fetching training partner list", error);
    //     }
    // }

    PartnerComponent = async () => {
        let listComponent = ['THSC', 'TIMES-PRO'];
        listComponent = listComponent.map((item) => {
            return { label: item, value: item.toLocaleLowerCase() };
        });
        this.setState({
            setPartnerList: listComponent,
        });
    };

    setTrainingPartnerListComponent = async (selectedPartner, list) => {
        let listComponent = [];
        list.forEach((item) => {
            if (item.partner_name === selectedPartner) {
                if (item.training_partner) {
                    listComponent.push({ label: item.training_partner, value: item._id });
                }
            }
        });
        this.setState({
            setTrainingPartnerComponent: listComponent,
        });
    };

    setListComponent = async () => {
        let metaData = JSON.parse(localStorage.getItem('metadata'))
            ? JSON.parse(localStorage.getItem('metadata'))
            : [];
        if (metaData && metaData.length === 0) {
            metaData = await fetchMetadata();
        }
        const companyMetaData = metaData?.[0]?.meta_data?.companies || [];
        const listComponent = companyMetaData.map((item) => {
            if (this.props.location.state) {
                if (this.props.location.state.company_id === item.company_id) {
                    this.setState({
                        selectedEmployer: { label: item.company_name, value: item.company_id },
                    });
                }
            }
            return { label: item.company_name, value: item.company_id };
        });
        this.setState({
            employerListComponent: listComponent,
        });
    };

    setEmployerUnitListComponent = (event) => {
        let list = [];
        this.state.employerList.forEach((item) => {
            if (event.label === item.employer_name) {
                list.push({ label: item.unit_name, value: item._id });
                this.setState({
                    employerUnit: null,
                });
            }

            if (list.length === 0) {
                this.setState({
                    setDisableEmployerUnit: true,
                    employerUnit: null,
                });
            } else {
                this.setState({
                    setDisableEmployerUnit: false,
                });
            }
        });
        this.setState({
            employerUnitComponent: list,
        });
    };

    // fetchEmployerList = async () => {
    //     try {
    //         const data = await getEmployerList({},{});
    //         this.setState({
    //             employerList: data.data.result
    //         }, () => {
    //             this.state.employerList.forEach((item) => {
    //                 if (this.state.employerUnit) {
    //                     if (item._id === this.state.employerUnit.value) {
    //                         this.setState({
    //                             employerUnit: { label: item.unit_name, value: item._id }
    //                         })
    //                     }
    //                 }
    //             });
    //         })
    //         this.setListComponent();
    //     }
    //     catch (error) {
    //         console.log("error while fetching data", error);
    //     }
    // }

    handleProfileChange = (event) => {
        if (event.label === 'Employer') {
            this.setState({
                selectedEmployer: null,
                employerUnit: null,
            });
        }
        if (event.label === 'Training Partner') {
            this.setState({
                selectedPartner: null,
                selectedTrainingPartner: null,
            });
        }
        this.setState({
            selectProfile: { label: event.label, value: event.value },
        });
        const findObject = this.state.roleListComponent.find(
            (findItem) => findItem.label.toLocaleLowerCase() === event.label.toLocaleLowerCase()
        );
        if (findObject) {
            this.setState({
                userRole: findObject,
            });
        }
    };

    changeProgram = (event) => {
        if (event.label === 'TIMES-PRO') {
            this.setState({
                selectedTrainingPartner: null,
                setDisableTrainingPartner: true,
            });
        } else {
            this.setState({
                setDisableTrainingPartner: false,
            });
        }
        this.setState(
            {
                selectedPartner: { label: event.label, value: event.value },
            },
            () => {
                this.setTrainingPartnerListComponent(event.label, this.state.partnerList);
            }
        );
    };

    changeTrainingParnter = (event) => {
        this.setState({
            selectedTrainingPartner: { label: event.label, value: event.value },
        });
    };

    changeCompany = (event) => {
        this.setState(
            {
                selectedEmployer: { label: event.label, value: event.value },
            },
            () => {
                this.setEmployerUnitListComponent(event);
            }
        );
    };

    changeEmployerUnit = (event) => {
        this.setState({
            employerUnit: { label: event.label, value: event.value },
        });
    };

    render() {
        if (this.state.isLoading) {
            return <Spinner />;
        } else {
            return (
                <div className="main-content">
                    <div className="back">
                        <ul className="breadcrumb1">
                            <li>
                                <a href="/user-page">User Master</a>
                            </li>
                            {this.state.userId === null ? (
                                <li>Add New User</li>
                            ) : (
                                <li>Edit User</li>
                            )}
                        </ul>
                    </div>
                    <div className="add-user-wrapper">
                        <div className="mx-auto text-left border create-user-div">
                            <form onSubmit={this.handleSubmit} className="pt-1">
                                <div className="user-icon-wrapper">
                                    <h4>
                                        {this.state.userId === null ? 'Add New User' : 'Edit User'}
                                    </h4>
                                    <i className={`${USER_ICON} list-table-icon`}></i>
                                </div>

                                <div className="row mt-0">
                                    <div className="input-label-group col-md-6">
                                        <label className="form-label">
                                            First Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                            value={this.state.firstName}
                                            onChange={this.firstNameChangeHandler}
                                            placeholder="Enter First Name"
                                        />
                                        <div className="text-danger error-msg">
                                            {this.state.error.firstName}
                                        </div>
                                    </div>
                                    <div className="input-label-group col-md-6">
                                        <label className="form-label">
                                            Last Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                            value={this.state.lastName}
                                            onChange={this.lastNameChangeHandler}
                                            placeholder="Enter Last Name"
                                        />
                                        <div className="text-danger error-msg">
                                            {this.state.error.lastName}
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-0">
                                    <div className="input-label-group col-md-6 email-input">
                                        <label className="form-label">
                                            Email Id <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height lowercase-email"
                                            value={this.state.emailId}
                                            onChange={this.emailIdChangeHandler}
                                            placeholder="Enter Email Id"
                                            disabled={this.state.isFromProfile}
                                            onBlur={this.emailUniqueHandler}
                                        />
                                        <div className="text-danger error-msg">
                                            {this.state.error.emailId}
                                        </div>
                                    </div>
                                    <div className="input-label-group col-md-6">
                                        <label className="form-label">
                                            Phone Number <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                            value={this.state.phoneNumber}
                                            onChange={this.phoneNumberChangeHandler}
                                            placeholder="Enter Phone Number"
                                            maxLength="10"
                                        />
                                        <div className="text-danger error-msg">
                                            {this.state.error.phoneNumber}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row mt-0">
                                    <div className="col-md-6">
                                        <div className="form-wrap">
                                            <label className="form-label-outside" htmlFor="general-information-skills">Select Profile</label>
                                            <div className="form-wrap-inner">
                                                <Select
                                                    className={"add-user-input-height"}
                                                    placeholder={`Select Profile`}
                                                    options={this.state.profileOptions}
                                                    value={this.state.selectProfile}
                                                    onChange={this.handleProfileChange}
                                                    isSearchable={true}
                                                    isMulti={false}
                                                    isDisabled={this.state.isFromProfile}
                                                />
                                            </div>
                                        </div>
                                        <div className="text-danger error-msg">
                                            {this.state.error.selectProfileError}
                                        </div>
                                    </div>
                                </div> */}
                                {this.state.selectProfile.label === 'Employer' && (
                                    <div className="row">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">
                                                Select Company{' '}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="form-wrap-inner">
                                                <Select
                                                    placeholder={`Select Company`}
                                                    value={this.state.selectedEmployer}
                                                    onChange={this.changeCompany}
                                                    options={this.state.employerListComponent}
                                                    isSearchable={true}
                                                    isMulti={false}
                                                    isDisabled={this.state.isFromProfile}
                                                />
                                            </div>
                                            <div className="text-danger error-msg">
                                                {this.state.error.selectedEmployerError}
                                            </div>
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">
                                                Select Employer Unit{' '}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="form-wrap-inner">
                                                <Select
                                                    placeholder={`Select Employer Unit`}
                                                    value={this.state.employerUnit}
                                                    onChange={this.changeEmployerUnit}
                                                    options={this.state.employerUnitComponent}
                                                    isSearchable={true}
                                                    isMulti={false}
                                                    isDisabled={this.state.setDisableEmployerUnit}
                                                />
                                            </div>
                                            <div className="text-danger error-msg">
                                                {this.state.error.employerUnitError}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {this.state.selectProfile.label === 'Training Partner' && (
                                    <div className="row">
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">
                                                Select Program{' '}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="form-wrap-inner">
                                                <Select
                                                    placeholder={`Select Program`}
                                                    value={this.state.selectedPartner}
                                                    onChange={this.changeProgram}
                                                    options={this.state.setPartnerList}
                                                    isSearchable={true}
                                                    isMulti={false}
                                                    isDisabled={this.state.isFromProfile}
                                                />
                                            </div>
                                            <div className="text-danger error-msg">
                                                {this.state.error.selectedPartnerError}
                                            </div>
                                        </div>
                                        <div className="input-label-group col-md-6">
                                            <label className="form-label">
                                                Select Training Partner{' '}
                                                <span className="text-danger">*</span>{' '}
                                            </label>
                                            <div className="form-wrap-inner">
                                                <Select
                                                    placeholder={`Select  Training Partner`}
                                                    value={this.state.selectedTrainingPartner}
                                                    onChange={this.changeTrainingParnter}
                                                    options={this.state.setTrainingPartnerComponent}
                                                    isSearchable={true}
                                                    isDisabled={
                                                        this.state.setDisableTrainingPartner
                                                    }
                                                />
                                            </div>
                                            <div className="text-danger error-msg">
                                                {this.state.error.selectedTrainingPartnerError}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="row">
                                    <div className="input-label-group col-md-6 email-input">
                                        <label className="form-label">
                                            User Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                            value={this.state.userName}
                                            onChange={this.userNameChangeHandler}
                                            onBlur={this.usernameUniqueHandler}
                                            placeholder="Enter User Name"
                                            disabled={this.state.isFromProfile}
                                        />
                                        <div className="text-danger error-msg">
                                            {this.state.error.userName}
                                        </div>
                                    </div>
                                </div>
                                <div className="row password-row">
                                    <div className="input-label-group col-md-6">
                                        <label className="form-label">
                                            Password <span className="text-danger">*</span>
                                        </label>
                                        <div className="password-input-div">
                                            {this.state.showPassword === true ? (
                                                <>
                                                    <input
                                                        type="text"
                                                        className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                                        value={this.state.password}
                                                        onChange={this.passwordChangehandler}
                                                        placeholder="Enter Password"
                                                        disabled={this.state.userId ? true : false}
                                                    />
                                                    <i
                                                        className={`${EYE_SLASH_ICON} eye-icon-class-for-password`}
                                                        onClick={this.handleShowPasswordClick}
                                                        title="View password"
                                                    ></i>
                                                </>
                                            ) : (
                                                <>
                                                    <input
                                                        type="password"
                                                        className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                                        value={this.state.password}
                                                        onChange={this.passwordChangehandler}
                                                        placeholder="Enter Password"
                                                        disabled={this.state.userId ? true : false}
                                                    />
                                                    <i
                                                        className={`${EYE_ICON} eye-icon-class-for-password`}
                                                        onClick={this.handleShowPasswordClick}
                                                        title="View password"
                                                    ></i>
                                                </>
                                            )}
                                        </div>
                                        <div className="text-danger error-msg">
                                            {this.state.error.password}
                                        </div>
                                    </div>
                                    <div className="input-label-group col-md-6">
                                        <label className="form-label">
                                            Confirm Password <span className="text-danger">*</span>
                                        </label>
                                        <div className="password-input-div">
                                            {this.state.showConfirmPassword === true ? (
                                                <>
                                                    <input
                                                        type="text"
                                                        className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height text-transform-none"
                                                        value={this.state.confirmPassword}
                                                        onChange={this.confirmPasswordChangehandler}
                                                        placeholder="Confirm Password"
                                                        disabled={this.state.userId ? true : false}
                                                    />
                                                    <i
                                                        className={`${EYE_SLASH_ICON} eye-icon-class-for-password`}
                                                        onClick={
                                                            this.handleShowConfirmPasswordClick
                                                        }
                                                        title="View Password"
                                                    ></i>
                                                </>
                                            ) : (
                                                <>
                                                    <input
                                                        type="password"
                                                        className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height text-transform-none"
                                                        value={this.state.confirmPassword}
                                                        onChange={this.confirmPasswordChangehandler}
                                                        placeholder="Confirm Password"
                                                        disabled={this.state.userId ? true : false}
                                                    />
                                                    <i
                                                        className={`${EYE_ICON} eye-icon-class-for-password`}
                                                        onClick={
                                                            this.handleShowConfirmPasswordClick
                                                        }
                                                        title="View Password"
                                                    ></i>
                                                </>
                                            )}
                                        </div>
                                        <div className="text-danger error-msg">
                                            {this.state.error.confirmPassword}
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-0">
                                    <div className="col-md-6">
                                        <div className="form-wrap">
                                            <label
                                                className="form-label-outside"
                                                htmlFor="general-information-skills"
                                            >
                                                User Role{' '}
                                            </label>
                                            <div className="form-wrap-inner">
                                                <Select
                                                    placeholder={`Select User Role`}
                                                    value={this.state.userRole}
                                                    onChange={this.userRoleChaneHandler}
                                                    options={this.state.roleListComponent}
                                                    isSearchable={true}
                                                    isDisabled={this.state.isFromProfile}
                                                />
                                            </div>
                                        </div>
                                        <div className="text-danger error-msg">
                                            {this.state.error.userRole}
                                        </div>
                                    </div>
                                    {this.state.showRegion && (
                                        <div className="col-md-6">
                                            <div className="form-wrap">
                                                <label className="form-label-outside">Select Region</label>
                                                <div className="form-wrap-inner">
                                                    <Select
                                                        placeholder="Select Region"
                                                        value={this.state.selectedRegions}
                                                        onChange={this.regionChangeHandler}
                                                        options={this.state.regionListComponent}
                                                        isMulti
                                                        isSearchable
                                                        isDisabled={this.state.isFromProfile}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-danger error-msg">{this.state.error.region}</div>
                                        </div>
                                    )} 
                                </div>
                                <div className="row mt-0 mt-4 mb-5 display-inline">
                                    <div className="form-button-div">
                                        <button
                                            className="brand-button"
                                            onClick={this.createUserHandler}
                                        >
                                            {this.state.userId ? 'Update' : 'Create'}
                                        </button>
                                        <button
                                            className="cancel_button ml-5"
                                            onClick={this.cancelHandler}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="row dummy_row"></div>
                </div>
            );
        }
    }
}

export default CreateUserPage;